// ============================================================================
// MOCK DATA — École des Maîtres Dauphins (Page Promo 2026)
// All content sourced from gillesdelieuze.com. Frontend-only mock.
// Video testimonials use PLACEHOLDER YouTube IDs — replace `youtubeId`
// with the real YouTube video IDs from the site.
// ============================================================================

export const LINKS = {
  inscription: "https://gillesdelieuze.com/bdc-ecole-maitres-dauphins/",
  rdvClarte: "https://gillesdelieuze.com/rdv-clarte-2/",
  therapeutes: "https://gillesdelieuze.com/cursus-therapeutes-ecole-dauphins/",
  email: "gilles@centre-terre-ciel.com",
};

export const NAV_ITEMS = [
  { label: "Le portail", href: "#portail" },
  { label: "Fréquences", href: "#frequences" },
  { label: "Programme", href: "#modules" },
  { label: "Témoignages", href: "#temoignages" },
  { label: "Tarifs", href: "#tarifs" },
  { label: "FAQ", href: "#faq" },
];

export const HERO = {
  eyebrow: "Plonge dans",
  title1: "L'École des",
  title2: "Maîtres Dauphins",
  subtitle:
    "Un chemin pour vibrer plus fort, aimer ta vie… et, si tu le choisis, transmettre cette fréquence.",
  para1: "Pour toi qui veux retrouver la joie, la fluidité et le sens.",
  para2: "Pour toi qui veux accompagner avec intégrité et puissance.",
  image:
    "https://images.unsplash.com/photo-1674030572169-66f3a755b8d5?crop=entropy&cs=srgb&fm=jpg&q=90&w=1100&ixlib=rb-4.1.0",
  badgeFreq: "14 fréquences",
  badgeMembers: "+500 membres transformés",
};

export const PILLARS = [
  {
    tag: "SOIN",
    text: "Te libérer de tes blessures de vie, karmiques et transgénérationnelles.",
    icon: "HeartPulse",
  },
  {
    tag: "RÉVÉLATION",
    text: "Révéler les trésors cachés de ta personnalité (ce pour quoi tu t'es incarné·e).",
    icon: "Sparkles",
  },
  {
    tag: "RAYONNEMENT",
    text: "Oser être visible et prendre ta place (sans peur du jugement).",
    icon: "Sun",
  },
  {
    tag: "POTENTIELS",
    text: "Réveiller les pouvoirs énergétiques et psychiques qui dorment en toi.",
    icon: "Zap",
  },
  {
    tag: "MISSION",
    text: "Devenir praticien en soins quantiques.",
    icon: "Compass",
  },
];

export const FOR_YOU = [
  "Retrouve la joie de vivre",
  "Libérer tes blocages intérieurs",
  "Reconnecte ton corps et ton âme",
  "Kiffe ta vie, pleinement incarné(e)",
];

export const FOR_PRACTITIONERS = [
  "Intègre des outils vibratoires uniques",
  "Donne des soins profonds et éthiques",
  "Déploie ta puissance lumineuse",
  "Transforme tes accompagnements",
];

export const FIT_LIST = [
  "tu es fatigué(e) de « comprendre » sans que ta réalité suive",
  "tu veux arrêter de te corriger et commencer à te déployer",
  "tu veux une joie stable, pas un shoot d'inspiration",
  "tu veux une spiritualité incarnée : corps, émotion, choix, présence",
  "tu sens que tu es prêt(e) à changer de niveau (un vrai)",
];

export const FREQUENCES = [
  {
    title: 'Ressentir que tu es enfin arrivé·e « à la maison »',
    text: "Tu vas apprendre à vivre dans cet état de haute vibration au quotidien.",
    image:
      "https://gillesdelieuze.com/wp-content/uploads/2025/02/gilles1385_figurative_futurist_photo_human_body_with_chakras_li_f3b9c26d-4156-4461-aafe-d50d95afe9b1.png",
  },
  {
    title: "Retirer couches après couches ce qui t'empêche d'être heureux·se",
    text: "Libéré·e des deuils, déceptions et traumatismes, tu te sentiras plus léger·e et confiant·e.",
    image:
      "https://gillesdelieuze.com/wp-content/uploads/2025/02/gilles1385_figurative_futurist_photo_of_woman_exprimant_la_paix_2193e425-c0b7-4671-913e-62e57f8d4064.png",
  },
  {
    title: "Faire la paix avec le passé",
    text: "Et toutes les émotions lourdes qui y sont associées. D'être présent·e à ce qui est.",
    image:
      "https://gillesdelieuze.com/wp-content/uploads/2025/05/gilles1385_Ultra-realistic_photo_of_a_powerful_woman_standing_i_f5941fa6-62e2-491f-b2bc-e1b9e6742aa6.png",
  },
  {
    title: "Vivre dans un état de conscience supérieure",
    text: "Tu vas apprendre à surfer la vie avec autant de fluidité qu'un dauphin.",
    image:
      "https://gillesdelieuze.com/wp-content/uploads/2024/11/gilles1385_renaissance_new_age_galactic_divine_white_gold_multi_7abf6662-243e-4ba3-95d7-b78d395cf370.png",
  },
  {
    title: "Développer tes capacités médiumniques",
    text: "Clairvoyance, intuition, vision du futur. L'énergie des Maîtres Dauphins t'ouvrira ce portail.",
    image:
      "https://gillesdelieuze.com/wp-content/uploads/2023/07/gilles_divinite_divine_gold_ascension_avatar_ai_mythos_mystic_Q_90fc83b3-63ab-499d-9605-015536818f16.png",
  },
  {
    title: "Le mécanisme signature · Cloud & Timeline",
    text: "Tu te reconnectes à une version plus haute de toi… puis tu l'installes dans la matière.",
    image:
      "https://gillesdelieuze.com/wp-content/uploads/2025/02/gilles1385_an_anime_style_and_luminous_dolphin_is_glowing_green_f8912b72-a338-40aa-a4cb-75effd9294b7-574x1024.png",
  },
];

export const CLOUD_TIMELINE = [
  {
    title: "Le Cloud de potentialités",
    text: "Tu as en toi des ressources qui ne sont pas accessibles en continu. L'École est conçue comme un Cloud : tu te reconnectes à une version plus haute de toi.",
    icon: "CloudLightning",
  },
  {
    title: "Le saut quantique",
    text: 'Au lieu de réparer « morceau par morceau », tu changes d\'état. Et quand ton état change, tes choix changent.',
    icon: "Atom",
  },
  {
    title: 'La signature « dauphin »',
    text: "Ici, ce n'est pas un décor : c'est une qualité d'être. Fluidité, cohérence, présence, joie-force, vérité simple.",
    icon: "Waves",
  },
];

export const MODULES = [
  { n: 1, color: "Dauphin rouge", name: "Kalim", title: "Libération des mémoires transgénérationnelles", hex: "#e0464b", image: "https://gillesdelieuze.com/wp-content/uploads/2024/09/gilles1385_red_galactic_Dolphin_cosmos_energy_divine_futuriste__757316d6-f200-40bb-b0ad-96096234844e.png" },
  { n: 2, color: "Dauphin orange", name: "Shampa Takir", title: "Le déblocage de ton plein potentiel", hex: "#f0873a", image: "https://gillesdelieuze.com/wp-content/uploads/2024/09/gilles1385_dauphin_orange_Dolphin_animal_on_first_plan_and_back_09df74af-0066-4a87-80af-166eada9dd41.png" },
  { n: 3, color: "Dauphin jaune", name: "Ra Limpaga", title: "La pacification des colères", hex: "#f2c94c", image: "https://gillesdelieuze.com/wp-content/uploads/2024/10/gilles1385_photo_futuriste_figuratif_Dolphin_Celestial_Yellow_d_70b3a3e7-b643-4643-ab82-3f3056bdcdee.png" },
  { n: 4, color: "Dauphin vert", name: "Étoile Atlante", title: "Renforcer corps et mental par la respiration", hex: "#27ae8f", image: "https://gillesdelieuze.com/wp-content/uploads/2024/11/gilles1385_photo_futuriste_figuratif_Dolphin_Celestial_green_da_a98140e4-6ba3-4494-9961-363df18719aa.png" },
  { n: 5, color: "Dauphin rose", name: "Shanella", title: "La guérison d'une blessure d'amour", hex: "#ec6fa8", image: "https://gillesdelieuze.com/wp-content/uploads/2024/11/gilles1385_photo_futuriste_figuratif_Dolphin_Celestial_rose_dau_74da70fd-fc44-4eb5-bc3a-2248cc164c13.png" },
  { n: 6, color: "Dauphin turquoise", name: "Logacy", title: "La joie de ton enfant intérieur", hex: "#2bd3c9", image: "https://gillesdelieuze.com/wp-content/uploads/2024/11/gilles1385_photo_futuriste_figuratif_Dolphin_Celestial_turquois_8cbec288-5125-4e13-8bab-c1d122dcb180.png" },
  { n: 7, color: "Dauphin bleu", name: "Extensia", title: "Communication fluide & relations épanouies", hex: "#3a8fe0", image: "https://gillesdelieuze.com/wp-content/uploads/2024/11/gilles1385_photo_futuriste_figuratif_Dolphin_Celestial_bleu_dau_2f1f455b-76ac-4c23-9567-ce8bc76c7c2e.png" },
  { n: 8, color: "Dauphin indigo", name: "Ajna activateur", title: "Activation de ta clairvoyance", hex: "#5a5ee0", image: "https://gillesdelieuze.com/wp-content/uploads/2024/11/gilles1385_photo_futuriste_figuratif_Dolphin_Celestial_indigo_d_51c6ca3d-1191-436e-be4a-41912420509f.png" },
  { n: 9, color: "Dauphin violet", name: "Galimpanem", title: "Traverser une transition sereinement", hex: "#9b59e0", image: "https://gillesdelieuze.com/wp-content/uploads/2024/11/gilles1385_photo_futuriste_figuratif_Dolphin_Celestial_violet_d_1528da77-503d-4b09-932a-c40dc1dccfaf.png" },
  { n: 10, color: "Dauphin blanc", name: "Sky light", title: "La découverte de ta mission d'âme", hex: "#e8eef7", image: "https://gillesdelieuze.com/wp-content/uploads/2024/11/gilles1385_photo_futuriste_figuratif_Dolphin_Celestial_white_da_a42dc523-fa81-4471-80c2-b289b761bab4.png" },
  { n: 11, color: "Dauphin arc-en-ciel", name: "Rainbow light", title: "Transmutation de tes ombres en lumière", hex: "#f2994a", image: "https://gillesdelieuze.com/wp-content/uploads/2024/11/gilles1385_photo_futuriste_figuratif_Dolphin_Celestial_rainbow__7d49a903-744c-4b40-b335-7a3073a0f6fa.png" },
  { n: 12, color: "Dauphin argent", name: "Silver light", title: "Libération de tous tes blocages", hex: "#c0c8d4", image: "https://gillesdelieuze.com/wp-content/uploads/2024/11/gilles1385_photo_futuriste_figuratif_Dolphin_Celestial_silver_d_738f26d2-3620-4dec-930a-723f453e057d.png" },
  { n: 13, color: "Dauphin or", name: "Elashim", title: "Harmonisation de tes 12 chakras", hex: "#d4af37", image: "https://gillesdelieuze.com/wp-content/uploads/2024/11/gilles1385_photo_futuriste_figuratif_Dolphin_Celestial_gold_dau_2af41b4c-93fa-4a0d-9f7b-d6944c5572d4.png" },
  { n: 14, color: "Dauphin diamant", name: "Diamant", title: "Alignement corps, esprit et âme", hex: "#7fd8e8", image: "https://gillesdelieuze.com/wp-content/uploads/2024/11/gilles1385_photo_futuriste_figuratif_Dolphin_Celestial_diamond__568ffd55-e58d-4455-b34f-975c4493bf84.png" },
];

export const PHASE2 = {
  image:
    "https://gillesdelieuze.com/wp-content/uploads/2024/11/gilles1385_soin_energetique_initiation_avec_les_dauphins_multid_dbedaed2-4935-4298-9aa6-7f5d969c568c-650x650.png",
  items: [
    { title: "Rétablir l'harmonie énergétique", text: "Grâce à la technique d'étirement des filaments." },
    { title: "Encoder des élixirs", text: "Comme les fleurs de Bach mais multidimensionnel." },
    { title: "Soigner dans la joie et le jeu", text: "Le secret d'un soin énergétique réussi." },
    { title: 'Activer ta « dolphin banane ! »', text: "Une technique de respiration qui active ton énergie vitale." },
    { title: "Recevoir une guidance Maîtres Dauphins", text: "Grâce à l'oracle, recevoir des messages personnalisés." },
  ],
};

export const BONUS = [
  {
    n: 1,
    value: "149€",
    title: "Le protocole chamanique des deuils et renaissances",
    text: "Libère l'ancien pour accueillir le nouveau grâce à ce puissant protocole.",
    image:
      "https://gillesdelieuze.com/wp-content/uploads/2024/11/gilles1385_renaissance_new_age_galactic_divine_white_gold_multi_7abf6662-243e-4ba3-95d7-b78d395cf370.png",
  },
  {
    n: 2,
    value: "231€",
    title: "3 transmissions · Baleine, Béluga, Raie",
    text: "Accède à des savoirs galactiques et comprends ta place dans le monde.",
    image:
      "https://gillesdelieuze.com/wp-content/uploads/2024/08/gilles1385_photo_art_ultrarealiste_Manta_ray_8K_cosmic_electric_cf2f4728-073c-4bc5-8622-ea475fb68dac.png",
  },
  {
    n: 3,
    value: "180€",
    title: "Sommet Métamorphose · oser prendre TA PLACE",
    text: "5 clés pour suivre ta voix et 7 pépites pour lancer une activité alignée.",
    image:
      "https://gillesdelieuze.com/wp-content/uploads/2024/04/DALL%C2%B7E-2024-05-07-16.23.02-Create-a-high-resolution-digital-artwork-depicting-the-concept-of-equanimous-presence-with-enhancements.-The-image-should-feature-a-central-serene-fi.webp",
  },
];

export const TESTIMONIALS = [
  { quote: "Je croyais avoir perdu ma joie depuis longtemps… mais dès la première immersion avec Gilles et l'énergie des dauphins, j'ai senti un souffle nouveau. J'ai recommencé à rire sans raison, comme une enfant.", name: "Claire", age: "42 ans", role: "Professeure des écoles" },
  { quote: "J'accompagne déjà des patients, mais je n'avais jamais ressenti une telle puissance dans mes soins. J'ai intégré un souffle de légèreté et mes clients l'ont immédiatement perçu.", name: "Daniel", age: "35 ans", role: "Thérapeute Holistique" },
  { quote: "J'étais épuisée, perdue dans mes choix de vie. Cette école m'a reconnectée à une joie simple et profonde. Je me sens à nouveau vivante et confiante dans mon chemin.", name: "Mélanie", age: "28 ans", role: "Doctorante en Psychologie" },
  { quote: "C'est un nouveau départ pour moi, à un moment où je devais faire un reset total. J'ai trouvé auprès des dauphins et de Gilles le soutien dont j'avais besoin pour poser de nouvelles fondations solides.", name: "Sandrine M.", age: "", role: "Juriste en reconversion" },
  { quote: "J'ai fait beaucoup de formations et souvent je n'allais pas au bout. Après 8 mois je peux affirmer que je me métamorphose. Au-delà de techniques, tu nous apportes une philosophie de vie profonde.", name: "Natacha Pradier", age: "", role: "Coach en développement personnel" },
  { quote: "Retraitée depuis 10 ans, j'ai longuement hésité. Je me félicite d'avoir contré le mental car je me retrouve. Mon quotidien pétille à nouveau, je ressens beaucoup de paix et de joie.", name: "Luce A.", age: "", role: "Retraitée" },
];

// Video testimonials — real YouTube videos (order preserved).
// Shorts are vertical (portrait). Rename `name`/`role` freely.
export const VIDEO_TESTIMONIALS = [
  { name: "Nathalie", role: "Membre de l'École", youtubeId: "wq97LcHac-Y", orientation: "portrait", thumb: "https://i.ytimg.com/vi/wq97LcHac-Y/hqdefault.jpg" },
  { name: "Christel", role: "Membre de l'École", youtubeId: "J_6D4OlME4Q", orientation: "landscape", thumb: "https://i.ytimg.com/vi/J_6D4OlME4Q/hqdefault.jpg" },
  { name: "Nelly", role: "Membre de l'École", youtubeId: "6KoL9imCXvA", orientation: "portrait", thumb: "https://i.ytimg.com/vi/6KoL9imCXvA/hqdefault.jpg" },
  { name: "Aline", role: "Membre de l'École", youtubeId: "iUdEMS21ryw", orientation: "portrait", thumb: "https://i.ytimg.com/vi/iUdEMS21ryw/hqdefault.jpg" },
];

// Extra descriptive content used in the module popup (Phase 1 carousel).
export const MODULE_DESC = {
  1: "Tu t'ancres profondément et dépasses les dénis d'incarnation, tout en libérant les mémoires familiales qui te pèsent depuis des générations.",
  2: "Tu renoues avec l'intelligence de ton corps et actives ton chakra sacré afin d'apprivoiser tes peurs et de débloquer ton plein potentiel.",
  3: "Tu lâches ton besoin de contrôle pour passer à l'art de la maîtrise et accueillir ta colère avec justesse et sérénité.",
  4: "Tu entres dans un portail dimensionnel puissant grâce au pouvoir de ta respiration qui renforce ton corps et ton mental.",
  5: "Tu te connectes à la conscience de la Mère divine pour guérir une blessure d'amour et vivre l'amour inconditionnel.",
  6: "Une rencontre émouvante avec ton enfant intérieur et toute la joie, l'innocence et la spontanéité qu'il porte en lui.",
  7: "Tu agis sur ton chakra de la gorge pour oser t'exprimer avec fluidité et vivre des relations épanouies.",
  8: "Tu es prêt·e à recevoir des guidances de ton Moi supérieur et à activer pleinement ta clairvoyance.",
  9: "LA fréquence delphique pour t'accompagner sereinement lors d'une transition difficile ou d'un nouveau départ.",
  10: "Un véritable saut quantique qui te permet de découvrir et de renouer avec ta mission d'âme.",
  11: "Des noces alchimiques : du plomb à l'or, tu vis une transmutation profonde de tes ombres en lumière.",
  12: "Nettoyage complet : ces fréquences éliminent tous les blocages qui affectent ton bien-être.",
  13: "Ces fréquences unifient et harmonisent tes 12 chakras et corps subtils pour toucher un état d'unité.",
  14: "Tu harmonises ton corps, ton esprit et ton âme pour atteindre un état d'alignement total.",
};

export const SCREENSHOTS = [
  "https://gillesdelieuze.com/wp-content/uploads/2024/11/IMG_1478-300x221.jpg",
  "https://gillesdelieuze.com/wp-content/uploads/2024/11/IMG_1479-219x300.jpg",
  "https://gillesdelieuze.com/wp-content/uploads/2024/11/IMG_1480-300x236.jpg",
  "https://gillesdelieuze.com/wp-content/uploads/2024/11/IMG_1481-300x283.jpg",
  "https://gillesdelieuze.com/wp-content/uploads/2024/11/IMG_1482-1024x666.jpg",
  "https://gillesdelieuze.com/wp-content/uploads/2024/11/Capture-decran-2024-11-07-a-12.15.22-1024x273.png",
];

export const ABOUT = {
  name: "Gilles Delieuze",
  role: "Mentor · Auteur · Enseignant",
  image: "https://gillesdelieuze.com/wp-content/uploads/2022/10/Gilles-2a-650x650.jpg",
  imageWide: "https://gillesdelieuze.com/wp-content/uploads/2022/12/Gilles-20c-1024x683.jpg",
  paras: [
    "Cela fait 27 ans que j'accompagne des personnes en quête d'un mieux-être et 18 ans que je suis un expert Dauphins.",
    "« Je sais la souffrance que cela génère de ne pas se sentir à sa place. D'être bloqué dans des schémas répétitifs. »",
    "En 2007, je reçois un « appel » mystique à 3h33. Une énergie se présente à moi sous le nom de « Maîtres Dauphins ». Cet appel m'a permis de sortir la tête de l'eau.",
  ],
};

export const NOT_LIKE = {
  isNot: [
    "Un cours théorique",
    "Une méthode à appliquer mécaniquement",
    "Un « quick fix » miracle",
    "Un stage de développement personnel classique",
  ],
  isYes: [
    "Une immersion vibratoire",
    "Un changement d'état de conscience",
    "Un retour à ton essence",
    "Une transmission vivante",
  ],
};

export const PRICING = {
  classique: {
    label: "Formule Classique",
    name: "École des Maîtres Dauphins",
    original: 2222,
    features: [
      "Formation complète avec accès illimité",
      "Modules de soins énergétiques",
      "5 fréquences bonus (Baleine, Béluga, Méduse, Hippocampe, Raie)",
      "Live Mensuel",
      "Bonus Dauphins hybrides",
      "Accès communauté active",
    ],
    options: [
      { label: "1x", sub: "Paiement unique", discount: 30, price: 1555, perMonth: null },
      { label: "2x", sub: "2 mensualités", discount: 25, price: 1667, perMonth: 834 },
      { label: "3x", sub: "3 mensualités", discount: 20, price: 1778, perMonth: 593 },
      { label: "5x", sub: "5 mensualités", discount: 20, price: 1778, perMonth: 356 },
      { label: "10x", sub: "10 mensualités", discount: 18, price: 1822, perMonth: 182 },
      { label: "12x", sub: "12 mensualités", discount: 15, price: 1889, perMonth: 157 },
      { label: "16x", sub: "16 mensualités", discount: 10, price: 2000, perMonth: 125 },
    ],
  },
  vip: {
    label: "Formule VIP",
    name: "École des Maîtres + Mentorat 1to1",
    original: 3333,
    features: [
      "Tout de la formule Classique",
      "Fil d'urgence prioritaire",
      "Mentorat et supervision 1to1 : 3 RDV d'1h30 avec Gilles",
    ],
    options: [
      { label: "1x", sub: "Paiement unique", discount: 30, price: 2333, perMonth: null },
      { label: "2x", sub: "2 mensualités", discount: 25, price: 2500, perMonth: 1250 },
      { label: "3x", sub: "3 mensualités", discount: 20, price: 2666, perMonth: 889 },
    ],
  },
};

export const FAQ = [
  { q: "« J'ai déjà fait plein de trucs. »", a: "Parfait. Ici, tu ne viens pas ajouter une couche. Tu viens changer le niveau d'accès : état → intégration → stabilisation." },
  { q: "« Je n'ai pas le temps. »", a: "Tu n'as pas besoin de 2 heures par jour. Tu as besoin d'un réglage régulier qui te remet dans l'axe. Et avec l'accès à vie, tu peux avancer à ton rythme et y revenir au besoin." },
  { q: "« Et si je retombe ? »", a: "C'est précisément pour ça qu'il y a intégration + stabilisation. Pas juste un déclic. Un nouveau normal." },
  { q: "« Et si je ne me sens pas prêt(e) ? »", a: "La vraie question : combien de temps tu veux encore vivre en dessous de ce qui t'appelle ?" },
  { q: "Je n'ai pas beaucoup de ressentis, est-ce que cela va fonctionner sur moi ?", a: "Bien sûr ! Ces énergies sont subtiles. Au début tu auras peut-être l'impression que rien ne se passe, mais tu vas constater que ton humeur change, ta façon de penser et d'agir se modifient. Très vite, tu vas ressentir l'énergie des dauphins qui t'accompagne au quotidien." },
  { q: "Je débute en spiritualité, est-ce que je peux m'inscrire ?", a: "Bien sûr ! Cette formation est conçue pour t'accompagner où que tu en sois dans ton cheminement. Le chemin est progressif, tu peux avancer à ton rythme." },
  { q: "Des fréquences dauphins, c'est pas un peu « perché » cette histoire ?", a: "J'ai été le premier surpris lorsque j'ai reçu ces transmissions delphiques par canalisation. J'étais plutôt cartésien avec mon parcours de juriste. Mais quand j'ai vu à quel point les Maîtres Dauphins ont transformé ma vie… j'ai accepté de ne pas tout comprendre !" },
  { q: "Quelle est la garantie satisfait ou remboursé ?", a: "Tu as 14 jours pour faire le test et découvrir le module 1, dans la limite de l'ouverture du Module 1. Si cela ne correspond pas à tes attentes : remboursement intégral." },
];

export const FINAL = {
  image:
    "https://gillesdelieuze.com/wp-content/uploads/2024/08/gilles1385_12_humains_qui_medites_avec_des_dauphins_de_cristal__21acedb8-2c3b-425f-80ee-927aebe800ab-650x650.png",
  title1: "Les Maîtres Dauphins t'attendent.",
  title2: "Et si c'était maintenant ton grand plongeon ?",
  guarantee: "Essaie 14 Jours · Satisfait ou Remboursé · Dans la limite de l'ouverture du Module 1",
  guaranteeImg: "https://gillesdelieuze.com/wp-content/uploads/2024/03/satisfait-1024x1024.png",
};
